"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMMAPreOrderShippingAddressComponent = void 0;
const core_1 = require("@angular/core");
const profileBillingAddress_1 = require("../../../models/Profile/profileBillingAddress");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
class CSMMAPreOrderShippingAddressComponent {
    constructor(orderService) {
        this.orderService = orderService;
        this.addressStatusEmitter = new core_1.EventEmitter();
        this.addressEmitter = new core_1.EventEmitter();
        this.isStateDropdownExpanded = false;
        this.isDiffAddressSaved = false;
        this.diffAddressState = '';
        this.addressNewCard = 'billingAddr';
        this.showDifferentAddressSection = false;
        this.selectedAdress = new profileBillingAddress_1.ProfileBillingAddress();
    }
    ngOnInit() {
        this.getStates();
    }
    ngOnChanges() {
        if (this.isVerifiedUser || !this.billingAddress) {
            this.addressNewCard = 'newAddress';
            this.setAddressStatus();
        }
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : (event.charCode >= 46 && event.charCode !== 47) && event.charCode <= 57;
    }
    getStates() {
        this.orderService.getAllStatesList().subscribe((data) => {
            this.stateList = data;
        }, (err) => {
            this.modalError = err;
        });
    }
    setAddressStatus() {
        this.showDifferentAddressSection = this.addressNewCard === 'newAddress';
        this.addressStatusEmitter.emit(this.addressNewCard);
    }
    setSelectedAddress() {
        if (this.isLoggedInUser && this.billingAddress) {
            this.selectedAdress.firstName = this.billingAddress.firstName;
            this.selectedAdress.lastName = this.billingAddress.lastName;
        }
        this.selectedAdress.address1 = this.diffAddressLine1;
        this.selectedAdress.address2 = this.diffAddressLine2;
        this.selectedAdress.state = this.diffAddressState;
        this.selectedAdress.city = this.diffAddressCity;
        this.selectedAdress.postalCode = this.diffAddressZip;
        this.isDiffAddressSaved = true;
        this.addressEmitter.emit(this.selectedAdress);
    }
    editSelectedAddress() {
        this.isDiffAddressSaved = false;
    }
    setStateDropdownStatus() {
        this.isStateDropdownExpanded = true;
    }
}
exports.CSMMAPreOrderShippingAddressComponent = CSMMAPreOrderShippingAddressComponent;
//# sourceMappingURL=shipping-address.component.js.map